export const products = [{
  sku: 'tshirt',
  appearance: 10,
  name: 'Classic T-Shirt',
  nameHe: 'חולצת טריקו קלאסית',
  description: 'Our Classic T-Shirt is made from 100% organic cotton, offering a comfortable fit and vibrant colors. Perfect for everyday wear and custom designs.',
  descriptionHe: `חולצת טריקו קלאסית בגזרה יוניסקס,
המתאימה לנשים ולגברים כאחד. עשויה מ-100% כותנה איכותית, במשקל 160 גרם,
המבטיחה מגע רך ונעים לצד עמידות גבוהה לשימוש יומיומי.\n\nמאפייני המוצר:\nהרכב הבד: 100% כותנה, בד נעים ואיכותי.\nגזרה: יוניסקס – מתאימה לכולם.\nצווארון: דק ונוח, בעיצוב קלאסי.\nמשקל הבד: 160 גרם, מושלם לכל עונות השנה.\n\nלמה לבחור בחולצת הטריקו שלנו?\nחולצה זו מספקת שילוב של נוחות, עיצוב קלאסי וגמישות מרבית, ומתאימה לשימוש יומיומי, עבודה או פעילות פנאי.\n\nבחרו את החולצה שלכם עכשיו והבטיחו לעצמכם איכות מעולה ונוחות מרבית!`,
  tech: 'DTF',
  search_tag: ['all', 'short_sleeve'],
  colors: ["white", "black", "gray", "red", "dark_gray", "royal_blue", "navy", "benetton_green", "bottle_green", "bordo", "purple", "tourquise", "orange", "yellow", "lightblue", "olive", "fuchsia", "brown", "banana_yellow", "apple_green", "natural"],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl', '4', '6', '8', '10', '12', '14', '16', '18'],
  images: {
    white: ['/product_images/tshirt/white_tshirt.jpg'],
    black: ['/product_images/tshirt/black_tshirt.jpg'],
    gray: ['/product_images/tshirt/gray_tshirt.jpg'],
    red: ['/product_images/tshirt/red_tshirt.jpg'],
    dark_gray: ['/product_images/tshirt/dark_gray_tshirt.jpg'],
    royal_blue: ['/product_images/tshirt/royal_blue_tshirt.jpg'],
    navy: ['/product_images/tshirt/navy_tshirt.jpg'],
    benetton_green: ['/product_images/tshirt/beneton_green_tshirt.jpg'],
    bottle_green: ['/product_images/tshirt/bottle_green_tshirt.jpg'],
    bordo: ['/product_images/tshirt/bordo_tshirt.jpg'],
    purple: ['/product_images/tshirt/purple_tshirt.jpg'],
    tourquise: ['/product_images/tshirt/tourquise_tshirt.jpg'],
    orange: ['/product_images/tshirt/orange_tshirt.jpg'],
    yellow: ['/product_images/tshirt/yellow_tshirt.jpg'],
    lilac: ['/product_images/tshirt/lilac_tshirt.jpg'],
    babypink: ['/product_images/tshirt/babypink_tshirt.jpg'],
    lightblue: ['/product_images/tshirt/lightblue_tshirt.jpg'],
    olive: ['/product_images/tshirt/olive_tshirt.jpg'],
    fuchsia: ['/product_images/tshirt/fuksia_tshirt.jpg'],
    brown: ['/product_images/tshirt/brown_tshirt.jpg'],
    banana_yellow: ['/product_images/tshirt/banana_yellow_tshirt.jpg'],
    apple_green: ['/product_images/tshirt/apple_green_tshirt.jpg'],
    natural: ['/product_images/tshirt/natural_tshirt.jpg'],
    base1: ['/product_images/tshirt/base1_tshirt.png'],
    base2: ['/product_images/tshirt/base2_tshirt.png']
  },
  activePrintAreas: ['leftChest', 'rightChest', 'frontA4', 'frontA3', 'backA4', 'backA3', 'leftSleeve', 'rightSleeve'],
  basePrice: 50,
  specs: {
    material: '100% cotton',
    materialHe: '100% כותנה',
    weight: '160 g',
    weightHe: '160 גרם',
    care: 'Machine wash cold, tumble dry low',
    careHe: 'כביסה במכונה במים קרים, ייבוש במכונה בטמפרטורה נמוכה'
  }
}, {
  sku: 'hoodie',
  appearance: 35,
  name: 'Premium Hoodie',
  nameHe: 'קפוצ׳ון פרימיום',
  description: 'Our Premium Hoodie is crafted from a heavyweight cotton blend for warmth and durability. Ideal for prints and comfortable layering.',
  descriptionHe: `הקפוצון כולל מנג'טים גמישים בידיים ובתחתית לשמירה על חום הגוף,
ועיצוב יוניסקס שמתאים גם לבנים וגם לבנות.
הגזרה הנוחה והחמימה הופכת אותו לאידיאלי לשימוש יומיומי וגם לאירועים בהם מחפשים שילוב של סטייל ונוחות.

יתרונות המוצר:
מנג'טים שמבטיחים שמירה על חום הגוף
עשוי מבד עבה במיוחד שמעניק תחושת חמימות מירבית
מתאים לימים קרים ולשימוש יומיומי
הרכב הבד:
65% כותנה, 35% פוליאסטר, סרוק 2 חוטים.`,
  tech: 'DTF',
  search_tag: ['all', 'winter'],
  colors: ['gray', 'red', 'blue', 'navy', 'benetongreen', 'bottlegreen', 'bordo', 'purple', 'tourquise', 'orange', 'yellow', 'babypink', 'lightblue', 'olive', 'brown'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl', '4', '6', '8', '10', '12', '14', '16', '18'],
  images: {
    white: ['/product_images/hoodie/white_hoodie.jpg', '/product_images/hoodie/white_hoodie.png'],
    black: ['/product_images/hoodie/black_hoodie.jpg', '/product_images/hoodie/black_hoodie.png'],
    gray: ['/product_images/hoodie/gray_hoodie.jpg', '/product_images/hoodie/dark_gray_hoodie.jpg', '/product_images/hoodie/gray_hoodie.png'],
    red: ['/product_images/hoodie/red_hoodie.jpg', '/product_images/hoodie/red_hoodie.png'],
    blue: ['/product_images/hoodie/blue_hoodie.jpg', '/product_images/hoodie/blue_hoodie.png'],
    navy: ['/product_images/hoodie/navy_hoodie.jpg', '/product_images/hoodie/navy_hoodie.png'],
    benetongreen: ['/product_images/hoodie/beneton_green_hoodie.jpg', '/product_images/hoodie/beneton_green_hoodie.png'],
    bottlegreen: ['/product_images/hoodie/bottlegreen_hoodie.jpg', '/product_images/hoodie/bottlegreen_hoodie.png'],
    bordo: ['/product_images/hoodie/bordo_hoodie.jpg', '/product_images/hoodie/bordo_hoodie.png'],
    purple: ['/product_images/hoodie/purple_hoodie.jpg', '/product_images/hoodie/lilac_hoodie.jpg'],
    tourquise: ['/product_images/hoodie/tourquise_hoodie.jpg', '/product_images/hoodie/tourquise_hoodie.png'],
    orange: ['/product_images/hoodie/orange_hoodie.jpg', '/product_images/hoodie/orange_hoodie.png'],
    yellow: ['/product_images/hoodie/yellow_hoodie.jpg', '/product_images/hoodie/banana_yellow_hoodie.jpg'],
    babypink: ['/product_images/hoodie/babypink_hoodie.jpg', '/product_images/hoodie/phosphor_pink_hoodie.jpg'],
    lightblue: ['/product_images/hoodie/lightblue_hoodie.jpg'],
    olive: ['/product_images/hoodie/olive_hoodie.jpg'],
    brown: ['/product_images/hoodie/brown_hoodie.jpg'],
    base1: ['/product_images/hoodie/base1_hoodie.png'],
    base2: ['/product_images/hoodie/base2_hoodie.png']
  },
  activePrintAreas: ['leftChest_long', 'rightChest_long', 'frontA4_long', 'backA4_long', 'backA3_long', 'leftSleeve_long', 'rightSleeve_long'],
  basePrice: 100
}, {
  sku: 'polo',
  appearance: 61,
  name: 'Classic Polo',
  nameHe: 'פולו קלאסי',
  description: 'A soft and breathable polo shirt suitable for corporate and casual wear, compatible with DTF printing.',
  descriptionHe: `תיאור המוצר:

חולצת פולו איכותית ומתאימה לתלבושות רשמיות בעבודה. 
החולצה מציעה גזרה רשמית, אידיאלית לעובדים שזקוקים למראה מסודר
ונעים לאורך יום העבודה. החולצה מתאימה במיוחד למי שמחפש פתרון רשמי ונוח בו זמנית.

יתרונות החולצה:

עשויה מ-60% כותנה ו-40% פוליאסטר
גזרה רשמית ומסודרת, מתאימה לתלבושות עובדים
נוחות ושמירה על מראה מסודר לאורך כל היום
הרכב הבד: 60% כותנה, 40% פוליאסטר.

צווארון: 3 כפתורים.`,
  tech: 'DTF',
  search_tag: ['all', 'short_sleeve'],
  colors: ['white', 'black', 'gray', 'red', 'blue', 'navy', 'benetongreen', 'bottlegreen', 'orange', 'yellow', 'babypink', 'lightblue', 'olive'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl'],
  images: {
    white: ['/product_images/polo/white_polo.jpg', '/product_images/polo/base1_polo.png'],
    black: ['/product_images/polo/black_polo.jpg', '/product_images/polo/base1_polo.png'],
    gray: ['/product_images/polo/gray_polo.jpg', '/product_images/polo/dark_gray_polo.jpg', '/product_images/polo/base1_polo.png'],
    red: ['/product_images/polo/red_polo.jpg', '/product_images/polo/royal_blue_polo.jpg', '/product_images/polo/base1_polo.png'],
    blue: ['/product_images/polo/royal_blue_polo.jpg', '/product_images/polo/blue_polo.jpg', '/product_images/polo/base1_polo.png'],
    navy: ['/product_images/polo/navy_blue_polo.jpg', '/product_images/polo/base1_polo.png'],
    benetongreen: ['/product_images/polo/beneton_green_polo.jpg', '/product_images/polo/apple_green_polo.jpg', '/product_images/polo/base1_polo.png'],
    bottlegreen: ['/product_images/polo/bottle_green_polo.jpg', '/product_images/polo/bottle_green_polo.jpg', '/product_images/polo/base1_polo.png'],
    orange: ['/product_images/polo/orange_polo.jpg', '/product_images/polo/base1_polo.png'],
    yellow: ['/product_images/polo/yellow_polo.jpg', '/product_images/polo/banana_yellow_polo.jpg', '/product_images/polo/base1_polo.png'],
    babypink: ['/product_images/polo/baby_pink_polo.jpg', '/product_images/polo/phosphor_pink_polo.jpg', '/product_images/polo/base1_polo.png'],
    lightblue: ['/product_images/polo/light_blue_polo.jpg', '/product_images/polo/base1_polo.png'],
    olive: ['/product_images/polo/olive_green_polo.jpg', '/product_images/polo/base1_polo.png'],
    bordo: ['/product_images/polo/bordo_polo.jpg', '/product_images/polo/base1_polo.png'],
    purple: ['/product_images/polo/purple_polo.jpg', '/product_images/polo/lilac_polo.jpg', '/product_images/polo/base1_polo.png'],
    tourquise: ['/product_images/polo/turquas_polo.jpg', '/product_images/polo/base1_polo.png'],
    brown: ['/product_images/polo/brown_polo.jpg', '/product_images/polo/base1_polo.png'],
    fuksia: ['/product_images/polo/fuksia_polo.jpg', '/product_images/polo/base1_polo.png'],
    natural: ['/product_images/polo/natural_polo.jpg', '/product_images/polo/base1_polo.png'],
    offwhite: ['/product_images/polo/offwhite_polo.jpg', '/product_images/polo/base1_polo.png'],
    phospor_green: ['/product_images/polo/phosphor_green_polo.jpg', '/product_images/polo/base1_polo.png'],
    base1: ['/product_images/polo/base1_polo.png'],
    base2: ['/product_images/polo/base2_polo.png']
  },
  activePrintAreas: ['leftChest', 'rightChest', 'backA4', 'leftSleeve', 'rightSleeve'],
  basePrice: 80
}, {
  sku: 'dryfit',
  appearance: 19,
  name: 'DryFit Sport Tee',
  nameHe: 'חולצת דרייפיט',
  description: 'Lightweight performance tee with moisture-wicking fabric, ideal for sports and events.',
  descriptionHe: `תיאור המוצר:

חולצת דרייפיט איכותית שמתאימה לפעילות ספורטיבית ולעבודה ממושכת.
הבד בעל יכולת נידוף זיעה מרשימה ומנטרל ריחות לא נעימים,
מה שהופך אותה לבחירה אידיאלית לפעילויות גופניות אינטנסיביות.
החולצה שומרת על תחושת יובש ונעימות לאורך זמן, כך שתוכל להרגיש נוח גם במהלך האימון הארוך ביותר.

היתרונות של החולצה:

נידוף זיעה אופטימלי.
אידיאלית לפעילויות ספורטיביות ולעבודה ממושכת.
תחושת יובש ונוחות לאורך זמן.
הרכב הבד: 100% פוליאסטר.

צווארון: עגול`,
  tech: 'DTF',
  search_tag: ['all', 'short_sleeve'],
  // use the same canonical color keys as other products (hoodie/polo/etc.)
  colors: ['white', 'black', 'gray', 'red', 'blue', 'navy', 'benetongreen', 'bottlegreen', 'bordo', 'purple', 'tourquise', 'orange', 'yellow', 'lilac', 'babypink', 'lightblue', 'olive', 'fuksia', 'brown', 'banana_yellow', 'apple_green', 'phosphor_yellow', 'phosphor_green', 'phosphor_pink'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl', '4', '6', '8', '10', '12', '14', '16', '18'],
  images: {
    white: ['/product_images/dryfit/white_dryfit.jpg'],
    black: ['/product_images/dryfit/black_dryfit.jpg'],
    gray: ['/product_images/dryfit/gray_dryfit.jpg'],
    red: ['/product_images/dryfit/red_dryfit.jpg'],
    blue: ['/product_images/dryfit/royal_blue_dryfit.jpg'],
    navy: ['/product_images/dryfit/navy_blue_dryfit.jpg'],
    benetongreen: ['/product_images/dryfit/beneton_green_dryfit.jpg'],
    bottlegreen: ['/product_images/dryfit/bottle_green_dryfit.jpg'],
    bordo: ['/product_images/dryfit/bordo_dryfit.jpg'],
    purple: ['/product_images/dryfit/purple_dryfit.jpg'],
    tourquise: ['/product_images/dryfit/turquas_dryfit.jpg'],
    orange: ['/product_images/dryfit/orange_dryfit.jpg'],
    yellow: ['/product_images/dryfit/yellow_dryfit.jpg', '/product_images/dryfit/banana_yellow_dryfit.jpg'],
    lilac: ['/product_images/dryfit/lilac_dryfit.jpg'],
    babypink: ['/product_images/dryfit/baby_pink_dryfit.jpg'],
    lightblue: ['/product_images/dryfit/light_blue_dryfit.jpg'],
    olive: ['/product_images/dryfit/olive_green_dryfit.jpg'],
    offwhite: ['/product_images/dryfit/offwhite_dryfit.jpg'],
    fuksia: ['/product_images/dryfit/fuksia_dryfit.jpg'],
    brown: ['/product_images/dryfit/brown_dryfit.jpg'],
    banana_yellow: ['/product_images/dryfit/banana_yellow_dryfit.jpg'],
    apple_green: ['/product_images/dryfit/apple_green_dryfit.jpg'],
    natural: ['/product_images/dryfit/natural_dryfit.jpg'],
    phosphor_yellow: ['/product_images/dryfit/phosphor_yellow_dryfit.jpg'],
    phosphor_green: ['/product_images/dryfit/phosphor_green_dryfit.jpg'],
    phosphor_pink: ['/product_images/dryfit/phosphor_pink_dryfit.jpg'],
    base1: ['/product_images/dryfit/base1_dryfit.png'],
    base2: ['/product_images/dryfit/base2_dryfit.png']
  },
  activePrintAreas: ['leftChest', 'rightChest', 'frontA4', 'frontA3', 'backA4', 'backA3', 'leftSleeve', 'rightSleeve'],
  basePrice: 60
}, {
  sku: 'fleece',
  appearance: 80,
  name: 'Light Fleece',
  nameHe: 'פליס קל',
  description: 'Soft fleece layer, suitable for cool weather and comfortable prints.',
  descriptionHe: `מעיל פליז חד צדדי איכותי וחמים, אידיאלי לשימוש יומיומי או פעילות חוץ.
המעיל עשוי מ-100% פוליאסטר, מה שמספק בידוד טוב ונוחות. הוא מצויד בכיסים לידיים וגומי תחתון להתאמה מושלמת לגוף.

מאפייני המוצר:
סוג: מעיל פליז חד צדדי
הרכב בד: 100% פוליאסטר
תכונות:
כיסים לידיים לנוחות
גומי תחתון להצמדה והתאמה לגוף
מעיל חמים ואיכותי
מתאים לפעילויות חוץ ויום-יומית. המעילמציע את השילוב המושלם של נוחות, חום ועיצוב פונקציונלי, ומתאים לשימושים מגוונים.`,
  tech: 'DTF',
  search_tag: ['all', 'winter'],
  colors: ['black', 'olive', 'navy'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl'],
  images: {
    black: ['/product_images/fleece/black_fleece.jpg'],
    olive: ['/product_images/fleece/olive_fleece.jpeg'],
    base1: ['/product_images/fleece/base1_fleece.png'],
    base2: ['/product_images/fleece/base2_fleece.png']
  },
  activePrintAreas: ['leftChest_long', 'rightChest_long', 'backA4_long', 'leftSleeve_long', 'rightSleeve_long'],
  basePrice: 120
}, {
  sku: 'longsleeve',
  appearance: 20,
  name: 'Long Sleeve Tee',
  nameHe: 'חולצת טריקו שרוול ארוך',
  description: 'A long-sleeve variant of our classic tee, great for cooler days and layered looks.',
  descriptionHe: `על המוצר
חולצת טריקו עם שרוול ארוך לשימוש יום-יומי ולעבודה. בחרו צבע ומידה מבין האפשרויות המוצגות בדף המוצר.
החולצה עשויה מבד איכותי ורך המעניק נוחות מרבית למשתמש לאורך כל שעות היום.
ניתן למיתוג אישי באמצעות הדפסה או רקמה של לוגו, סמל או שם, מה שהופך אותה לאידיאלית למתנות ממותגות, צוותי עבודה, יחידות צבאיות או אירועים.

מאפייני המוצר:
הרכב הבד: 100% כותנה.
גזרה: גזרה ישרה וסטנדרטית עם שרוולים ארוכים.
צווארון: עגול דק.
יתרונות המוצר:
נוחה ורב-שימושית – מתאימה לשימוש יום-יומי או לפעילות עבודה.
בד רך ונושם המותאם לאקלים משתנה.
מתאימה למיתוג אישי או עסקי: מושלמת לקבוצות, צוותי עבודה ויחידות צבאיות.
עמידה בכביסות מרובות ולשימוש ממושך.
שימושים מומלצים:
מתנות ממותגות ליחידות צבאיות, ארגונים וחברות.
חולצה לצוותי עבודה עם לוגו עסקי.
מדים לעובדים או חיילים.
אירועים קבוצתיים ופרויקטים ממותגים.`,
  tech: 'DTF',
  search_tag: ['all', 'winter'],
  colors: ['white', 'black', 'gray', 'red', 'blue', 'navy', 'benetongreen', 'bottlegreen', 'orange', 'yellow', 'babypink', 'lightblue', 'olive'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl', '8', '10', '12', '14', '16', '18'],
  images: {
    white: ['/product_images/longsleeve/white_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    black: ['/product_images/longsleeve/black_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    gray: ['/product_images/longsleeve/gray_longsleeve.jpg', '/product_images/longsleeve/dark_gray_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    red: ['/product_images/longsleeve/red_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    blue: ['/product_images/longsleeve/royal_blue_longsleeve.jpg', '/product_images/longsleeve/light_blue_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    navy: ['/product_images/longsleeve/navy_blue_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    benetongreen: ['/product_images/longsleeve/beneton_green_longsleeve.jpg', '/product_images/longsleeve/apple_green_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    bottlegreen: ['/product_images/longsleeve/bottle_green_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    orange: ['/product_images/longsleeve/orange_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    yellow: ['/product_images/longsleeve/yellow_longsleeve.jpg', '/product_images/longsleeve/banana_yellow_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    babypink: ['/product_images/longsleeve/baby_pink_longsleeve.jpg', '/product_images/longsleeve/phosphor_pink_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    lightblue: ['/product_images/longsleeve/light_blue_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    olive: ['/product_images/longsleeve/olive_green_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    bordo: ['/product_images/longsleeve/bordo_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    purple: ['/product_images/longsleeve/purple_longsleeve.jpg', '/product_images/longsleeve/lilac_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    tourquise: ['/product_images/longsleeve/turquas_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    brown: ['/product_images/longsleeve/brown_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    natural: ['/product_images/longsleeve/natural_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    offwhite: ['/product_images/longsleeve/offwhite_longsleeve.jpg', '/product_images/longsleeve/base1_longsleeve.png'],
    base1: ['/product_images/longsleeve/base1_longsleeve.png'],
    base2: ['/product_images/longsleeve/base2_longsleeve.png']
  },
  activePrintAreas: ['leftChest_long', 'rightChest_long', 'frontA4_long', 'frontA3_long', 'backA4_long', 'backA3_long', 'leftSleeve_long', 'rightSleeve_long'],
  basePrice: 60
}, {
  sku: 'longsleeve_dryfit',
  appearance: 21,
  name: 'Long Sleeve DryFit Tee',
  nameHe: 'חולצת דרייפיט שרוול ארוך',
  description: 'A lightweight long-sleeve performance tee made from moisture-wicking DryFit fabric for sports, work, and events.',
  descriptionHe: `חולצת דרייפיט שרוול ארוך, קלה ונוחה, המתאימה לפעילות ספורטיבית, לעבודה ולאירועים.
החולצה עשויה מ-100% פוליאסטר עם בד נושם ובעל יכולת נידוף זיעה, המסייע לשמור על תחושת יובש ונוחות לאורך זמן.

מאפייני המוצר:
הרכב הבד: 100% פוליאסטר.
גזרה: גזרה ישרה עם שרוולים ארוכים.
צווארון: עגול.
מתאימה למיתוג אישי באמצעות הדפסה בחזית, בגב, בחזה או על השרוולים.`,
  tech: 'DTF',
  search_tag: ['all', 'winter'],
  colors: ['white', 'black', 'gray', 'red', 'blue', 'navy', 'benetongreen', 'bottlegreen', 'orange', 'yellow', 'babypink', 'lightblue', 'olive'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl', '8', '10', '12', '14', '16', '18'],
  images: {
    white: ['/product_images/longsleeve_dryfit/white_longsleeve_dryfit.jpg'],
    black: ['/product_images/longsleeve_dryfit/black_longsleeve_dryfit.jpg'],
    gray: ['/product_images/longsleeve_dryfit/gray_longsleeve_dryfit.jpg'],
    red: ['/product_images/longsleeve_dryfit/red_longsleeve_dryfit.jpg'],
    blue: ['/product_images/longsleeve_dryfit/royal_blue_longsleeve_dryfit.jpg'],
    navy: ['/product_images/longsleeve_dryfit/navy_blue_longsleeve_dryfit.jpg'],
    benetongreen: ['/product_images/longsleeve_dryfit/beneton_green_longsleeve_dryfit.jpg'],
    bottlegreen: ['/product_images/longsleeve_dryfit/bottle_green_longsleeve_dryfit.jpg'],
    orange: ['/product_images/longsleeve_dryfit/orange_longsleeve_dryfit.jpg'],
    yellow: ['/product_images/longsleeve_dryfit/yellow_longsleeve_dryfit.jpg'],
    babypink: ['/product_images/longsleeve_dryfit/baby_pink_longsleeve_dryfit.jpg'],
    lightblue: ['/product_images/longsleeve_dryfit/light_blue_longsleeve_dryfit.jpg'],
    olive: ['/product_images/longsleeve_dryfit/olive_green_longsleeve_dryfit.jpg'],
    base1: ['/product_images/longsleeve_dryfit/base1_longsleeve_dryfit.jpg'],
    base2: ['/product_images/longsleeve_dryfit/base2_longsleeve_dryfit.jpg']
  },
  activePrintAreas: ['leftChest_long', 'rightChest_long', 'frontA4_long', 'frontA3_long', 'backA4_long', 'backA3_long', 'leftSleeve_long', 'rightSleeve_long'],
  basePrice: 60,
  specs: {
    material: '100% polyester',
    materialHe: '100% פוליאסטר'
  }
}, {
  sku: 'softshell',
  appearance: 90,
  name: 'Softshell Jacket',
  nameHe: 'ג׳קט סופטשל',
  description: 'A weather-resistant softshell layer ideal for outdoor branding and comfort.',
  descriptionHe: `על המוצר
מעיל סופטשל עם פרווה פנימית וכובע מוסתר – עמיד, חם ונוח
סוג מעיל: סופטשל חיצוני עם פרווה פנימית מחממת, כולל כובע ניילון מוסתר בתוך הצווארון.
הרכב הבד:
בד חיצוני: ניילון SOFTSHELL, עמיד במים (10,000 מ"מ) ואטום לרוח.
בד פנימי: פרווה רכה ונעימה למגע, המעניקה חימום מעולה.
יתרונות:
גמישות ונוחות המאפשרות פעילות ספורטיבית.
עיצוב קליל ואטום למים ולרוח.
מתאים לתנאי מזג אוויר משתנים.
מעיל הסופטשל שלנו משלב עמידות, חום ונוחות, ומותאם לפעילות יומיומית, ספורטיבית או עבודה בתנאי מזג אוויר מאתגרים.`,
  tech: 'DTF',
  search_tag: ['all', 'winter'],
  colors: ['black', 'olive'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl'],
  images: {
    black: ['/product_images/softshell/black_softshell.jpg'],
    olive: ['/product_images/softshell/olive_softshell.jpg'],
    base1: ['/product_images/softshell/base1_softshell.png'],
    base2: ['/product_images/softshell/base2_softshell.png']
  },
  activePrintAreas: ['leftChest', 'rightChest', 'backA4', 'leftSleeve', 'rightSleeve'],
  basePrice: 150
}, {
  sku: 'zipped_hood',
  appearance: 50,
  name: 'Zipped Hoodie',
  nameHe: 'קפוצ׳ון עם רוכסן',
  description: 'Zipped hoodie with roomy pockets and a comfortable fit, print friendly.',
  descriptionHe: `תיאור המוצר:

קפוצון פרימיום עשוי מ-65% כותנה ו-35% פוליאסטר, עם פוטר מגורד מבפנים שמעניק תחושת חמימות ונעימות.
הקפוצון כולל ריץ' רץ' לסגירה נוחה, כובע עם בטנה ומנג'טים בידיים ובתחתית, מה שמוסיף למראה ספורטיבי ומפנק.
הגזרה יוניסקס, מה שהופך אותו לאידיאלי עבור בנים ובנות כאחד.
קפוצון זה מצוין לשימוש יומיומי, פעילות ספורטיבית או כל פעילות חיצונית בשעות קרות.

יתרונות המוצר:

עשוי מ-65% כותנה ו-35% פוליאסטר
מרקם רך ונעים
עבה במיוחד ומחמם
ריץ' רץ' לסגירה נוחה
כובע עם בטנה
מנג'טים בידיים ובתחתית להשלמת המראה הספורטיבי
מתאים לשימוש יומיומי ולפעילויות ספורטיביות
מתאים לגברים ולנשים כאחד`,
  tech: 'DTF',
  search_tag: ['all', 'winter'],
  colors: ['white', 'black', 'gray', 'red', 'blue', 'navy', 'benetongreen', 'bottlegreen', 'bordo', 'purple', 'tourquise', 'orange', 'yellow', 'babypink', 'lightblue', 'olive', 'brown'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl', '8', '10', '12', '14', '16', '18'],
  images: {
    white: ['/product_images/zipped_hood/white_zipped_hood.jpg', '/product_images/zipped_hood/offwhite_zipped_hood.jpg'],
    black: ['/product_images/zipped_hood/black_zipped_hood.jpg'],
    gray: ['/product_images/zipped_hood/gray_zipped_hood.jpg', '/product_images/zipped_hood/dark_gray_zipped_hood.jpg'],
    red: ['/product_images/zipped_hood/red_zipped_hood.jpg'],
    blue: ['/product_images/zipped_hood/royal_blue_zipped_hood.jpg', '/product_images/zipped_hood/light_blue_zipped_hood.jpg'],
    navy: ['/product_images/zipped_hood/navy_blue_zipped_hood.jpg'],
    benetongreen: ['/product_images/zipped_hood/beneton_green_zipped_hood.jpg', '/product_images/zipped_hood/apple_green_zipped_hood.jpg'],
    bottlegreen: ['/product_images/zipped_hood/bottle_green_zipped_hood.jpg'],
    bordo: ['/product_images/zipped_hood/bordo_zipped_hood.jpg'],
    purple: ['/product_images/zipped_hood/purple_zipped_hood.jpg', '/product_images/zipped_hood/lilac_zipped_hood.jpg'],
    tourquise: ['/product_images/zipped_hood/turquas_zipped_hood.jpg', '/product_images/zipped_hood/tourquise_zipped_hood.jpg'],
    orange: ['/product_images/zipped_hood/orange_zipped_hood.jpg'],
    yellow: ['/product_images/zipped_hood/banana_yellow_zipped_hood.jpg', '/product_images/zipped_hood/yellow_zipped_hood.jpg', '/product_images/zipped_hood/phosphor_yellow_zipped_hood.jpg'],
    babypink: ['/product_images/zipped_hood/baby_pink_zipped_hood.jpg', '/product_images/zipped_hood/phosphor_pink_zipped_hood.jpg'],
    lightblue: ['/product_images/zipped_hood/light_blue_zipped_hood.jpg'],
    olive: ['/product_images/zipped_hood/olive_green_zipped_hood.jpg'],
    brown: ['/product_images/zipped_hood/brown_zipped_hood.jpg'],
    base1: ['/product_images/zipped_hood/base1_zipped_hood.png'],
    base2: ['/product_images/zipped_hood/base2_zipped_hood.png']
  },
  activePrintAreas: ['leftChest_long', 'rightChest_long', 'backA4_long', 'leftSleeve_long', 'rightSleeve_long'],
  basePrice: 110
}, {
  sku: 'sweatshirt',
  appearance: 40,
  name: 'Comfort Sweatshirt',
  nameHe: 'סווטשירט נוח',
  description: 'A soft, comfortable sweatshirt designed for everyday wear — breathable, warm and print-friendly.',
  descriptionHe: `תיאור המוצר:
שמספק תחושת נוחות ונעימות לאורך כל היום. הסווטשירט כולל מנג'טים בידיים ובתחתית,
המוסיפים למראה הספורטיבי והנעים. הגזרה נקייה ואלגנטית, ללא כובע או כיס,
מה שמאפשר לבשו להתאים למגוון אירועים ואופני לבוש. הסווטשירט מתאים לשימוש יומיומי, לפעילויות ספורטיביות או כפריט לבוש מחמם ומפנק.

יתרונות :

בד 3 חוטים סרוק טבעות לנעימות ועמידות
מנג'טים בידיים ובתחתית להשלמת המראה הספורטיבי
מתאים לשימוש יומיומי ולפעילויות ספורטיביות
עמיד וקל לתחזוקה
הרכב הבד: 70% כותנה, 30% פוליאסטר, בד 3 חוטים סרוק טבעות`,
  tech: 'DTF',
  search_tag: ['all', 'winter'],
  colors: ['white', 'black', 'gray', 'red', 'blue', 'navy', 'benetongreen', 'bottlegreen', 'orange', 'yellow', 'babypink', 'lightblue', 'olive'],
  sizeRange: ['s', 'm', 'l', 'xl', 'xxl', 'xxxl', 'xxxxl', 'xxxxxl', '8', '10', '12', '14', '16', '18'],
  images: {
    white: ['/product_images/sweatshirt/white_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    black: ['/product_images/sweatshirt/black_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    navy: ['/product_images/sweatshirt/navy_blue_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    red: ['/product_images/sweatshirt/red_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    gray: ['/product_images/sweatshirt/gray_sweatshirt.jpg', '/product_images/sweatshirt/dark_gray_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    blue: ['/product_images/sweatshirt/royal_blue_sweatshirt.jpg', '/product_images/sweatshirt/light_blue_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    benetongreen: ['/product_images/sweatshirt/beneton_green_sweatshirt.jpg', '/product_images/sweatshirt/apple_green_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    bottlegreen: ['/product_images/sweatshirt/bottle_green_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    orange: ['/product_images/sweatshirt/orange_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    yellow: ['/product_images/sweatshirt/yellow_sweatshirt.jpg', '/product_images/sweatshirt/banana_yellow_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    babypink: ['/product_images/sweatshirt/baby_pink_sweatshirt.jpg', '/product_images/sweatshirt/phosphor_pink_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    lightblue: ['/product_images/sweatshirt/light_blue_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    olive: ['/product_images/sweatshirt/olive_green_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    bordo: ['/product_images/sweatshirt/bordo_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    purple: ['/product_images/sweatshirt/purple_sweatshirt.jpg', '/product_images/sweatshirt/lilac_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    tourquise: ['/product_images/sweatshirt/turquas_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    brown: ['/product_images/sweatshirt/brown_sweatshirt.jpg', '/product_images/sweatshirt/base1_sweatshirt.png'],
    base1: ['/product_images/sweatshirt/base1_sweatshirt.png'],
    base2: ['/product_images/sweatshirt/base2_sweatshirt.png']
  },
  activePrintAreas: ['leftChest_long', 'rightChest_long', 'frontA4_long', 'frontA3_long', 'backA4_long', 'backA3_long', 'leftSleeve_long', 'rightSleeve_long'],
  basePrice: 80
}, {
  sku: "fleece_beanie",
  appearance: 122,
  name: "fleece_beanie",
  nameHe: "\u05DB\u05D5\u05D1\u05E2 \u05E4\u05DC\u05D9\u05E1",
  description: "fleece_beanie",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05E4\u05DC\u05D9\u05E1",
  tech: "DTF",
  search_tag: ["all", "winter", "headwear", "accessories"],
  colors: ["black", "olive"],
  sizeRange: ["one-size"],
  images: {
    base1: ["/product_images/fleece_beanie/base1_fleece_beanie.avif", "/product_images/fleece_beanie/base1_fleece_beanie.webp", "/product_images/fleece_beanie/base1_fleece_beanie.png"],
    base2: ["/product_images/fleece_beanie/base2_fleece_beanie.avif", "/product_images/fleece_beanie/base2_fleece_beanie.webp", "/product_images/fleece_beanie/base2_fleece_beanie.png"],
    black: ["/product_images/fleece_beanie/black_fleece_beanie.avif", "/product_images/fleece_beanie/black_fleece_beanie.webp", "/product_images/fleece_beanie/black_fleece_beanie.jpg"],
    olive: ["/product_images/fleece_beanie/olive_fleece_beanie.avif", "/product_images/fleece_beanie/olive_fleece_beanie.webp", "/product_images/fleece_beanie/olive_fleece_beanie.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 1
}, {
  sku: "scarf",
  appearance: 123,
  name: "scarf",
  nameHe: "\u05D7\u05DE\u05E6\u05D5\u05D5\u05D0\u05E8 \u05E4\u05DC\u05D9\u05E1",
  description: "scarf",
  descriptionHe: "\u05D7\u05DE\u05E6\u05D5\u05D5\u05D0\u05E8 \u05E4\u05DC\u05D9\u05E1",
  tech: "DTF",
  search_tag: ["all", "headwear", "winter"],
  colors: ["black", "olive", "navy"],
  sizeRange: ["one-size"],
  activePrintAreas: ["cap_front", "cap_back"],
  images: {
    base1: ["/product_images/scarf/base1_scarf.avif", "/product_images/scarf/base1_scarf.webp", "/product_images/scarf/base1_scarf.png"],
    base2: ["/product_images/scarf/base2_scarf.avif", "/product_images/scarf/base2_scarf.webp", "/product_images/scarf/base2_scarf.png"],
    black: ["/product_images/scarf/black_scarf.avif", "/product_images/scarf/black_scarf.webp", "/product_images/scarf/black_scarf.png"],
    olive: ["/product_images/scarf/olive_scarf.avif", "/product_images/scarf/olive_scarf.webp", "/product_images/scarf/olive_scarf.png"],
    navy: ["/product_images/scarf/navy_scarf.avif", "/product_images/scarf/navy_scarf.webp", "/product_images/scarf/navy_scarf.jpg"]
  },
  basePrice: 1
}, {
  sku: "KR2020",
  appearance: 130,
  name: "כובע בסיסי",
  nameHe: "כובע בסיסי",
  description: "5-panel cap with velcro closure, available in kids and adult sizes",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05DE\u05E6\u05D7\u05D9\u05D4, 5 \u05E4\u05D0\u05E0\u05DC \u05E1\u05D2\u05E8 \u05E1\u05E7\u05D5\u05E5\u2019 \u05D6\u05DE\u05D9\u05DF \u05D1\u05DE\u05D9\u05D3\u05EA \u05D9\u05DC\u05D3\u05D9\u05DD \u05D5\u05D1\u05DE\u05D9\u05D3\u05EA \u05DE\u05D1\u05D5\u05D2\u05E8\u05D9\u05DD",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "classic_baseball",
  colors: ["\u05E9\u05D7\u05D5\u05E8", "\u05DB\u05D7\u05D5\u05DC \u05E0\u05D9\u05D9\u05D1\u05D9", "\u05DB\u05D7\u05D5\u05DC \u05E8\u05D5\u05D9\u05D0\u05DC", "\u05D0\u05D3\u05D5\u05DD", "\u05D0\u05E4\u05D5\u05E8", "\u05DB\u05EA\u05D5\u05DD", "\u05E6\u05D4\u05D5\u05D1", "\u05D9\u05E8\u05D5\u05E7", "\u05DC\u05D1\u05DF"],
  sizeRange: ["kids", "adult"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560762/catalog/products/kraus/KR2020/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560762/catalog/products/kraus/KR2020/01.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560763/catalog/products/kraus/KR2020/02.jpg"],
    "כחול נייבי": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560764/catalog/products/kraus/KR2020/03.jpg"],
    "כחול רויאל": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560766/catalog/products/kraus/KR2020/04.jpg"],
    אדום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560767/catalog/products/kraus/KR2020/05.jpg"],
    אפור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560768/catalog/products/kraus/KR2020/06.jpg"],
    כתום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560769/catalog/products/kraus/KR2020/07.jpg"],
    צהוב: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560770/catalog/products/kraus/KR2020/08.jpg"],
    ירוק: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560770/catalog/products/kraus/KR2020/09.jpg"],
    לבן: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1775560772/catalog/products/kraus/KR2020/10.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 6
}, {
  sku: "KR2210",
  appearance: 131,
  name: "כובע מצחיה איכותי",
  nameHe: "כובע מצחיה איכותי",
  description: "\u05DB\u05D5\u05D1\u05E2 \u05DE\u05E6\u05D7\u05D9\u05D4, 6 \u05E4\u05D0\u05E0\u05DC 100% \u05DB\u05D5\u05EA\u05E0\u05D4 \u05E1\u05E8\u05D5\u05E7\u05D4 \u05E1\u05D2\u05E8 \u05DE\u05EA\u05DB\u05EA \u05DE\u05D9\u05D3\u05D4 59 \u05E1\u201D\u05DE",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05DE\u05E6\u05D7\u05D9\u05D4, 6 \u05E4\u05D0\u05E0\u05DC 100% \u05DB\u05D5\u05EA\u05E0\u05D4 \u05E1\u05E8\u05D5\u05E7\u05D4 \u05E1\u05D2\u05E8 \u05DE\u05EA\u05DB\u05EA \u05DE\u05D9\u05D3\u05D4 59 \u05E1\u201D\u05DE",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "classic_baseball",
  colors: ["\u05DC\u05D1\u05DF", "\u05D0\u05D3\u05D5\u05DD", "\u05DB\u05EA\u05D5\u05DD", "\u05DB\u05D7\u05D5\u05DC \u05E0\u05D9\u05D9\u05D1\u05D9", "\u05D0\u05E4\u05D5\u05E8", "\u05D9\u05E8\u05D5\u05E7 \u05D6\u05D9\u05EA", "\u05D8\u05D1\u05E2\u05D9", "\u05DB\u05D7\u05D5\u05DC \u05E8\u05D5\u05D9\u05D0\u05DC", "\u05E9\u05D7\u05D5\u05E8"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243302/catalog/products/kraus/KR2210/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243309/catalog/products/kraus/KR2210/11.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243303/catalog/products/kraus/KR2210/02.jpg"],
    "כחול רויאל": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243303/catalog/products/kraus/KR2210/03.jpg"],
    טבעי: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243304/catalog/products/kraus/KR2210/04.jpg"],
    "ירוק זית": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243305/catalog/products/kraus/KR2210/05.jpg"],
    אפור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243306/catalog/products/kraus/KR2210/06.jpg"],
    "כחול נייבי": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243306/catalog/products/kraus/KR2210/07.jpg"],
    כתום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243307/catalog/products/kraus/KR2210/08.jpg"],
    אדום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243307/catalog/products/kraus/KR2210/09.jpg"],
    לבן: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243308/catalog/products/kraus/KR2210/10.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 9
}, {
  sku: "KR2211",
  appearance: 132,
  name: "כובע רשת",
  nameHe: "כובע רשת",
  description: "\u05DB\u05D5\u05D1\u05E2 \u05DE\u05E6\u05D7\u05D9\u05D4 \u05E8\u05E9\u05EA 5 \u05E4\u05D0\u05E0\u05DC \u05D1\u05E9\u05D9\u05DC\u05D5\u05D1 \u05D1\u05D3 \u05DE\u05D9\u05E7\u05E8\u05D5\u05E4\u05D9\u05D9\u05D1\u05E8 \u05E1\u05D2\u05E8 \u05EA\u05D9\u05E7-\u05EA\u05E7 \u05DE\u05EA\u05D0\u05D9\u05DD \u05DC\u05DB\u05DC \u05E1\u05D5\u05D2\u05D9 \u05D4\u05D4\u05D3\u05E4\u05E1\u05D5\u05EA \u05DE\u05D9\u05D3\u05D4 59 \u05E1\u201D\u05DE",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05DE\u05E6\u05D7\u05D9\u05D4 \u05E8\u05E9\u05EA 5 \u05E4\u05D0\u05E0\u05DC \u05D1\u05E9\u05D9\u05DC\u05D5\u05D1 \u05D1\u05D3 \u05DE\u05D9\u05E7\u05E8\u05D5\u05E4\u05D9\u05D9\u05D1\u05E8 \u05E1\u05D2\u05E8 \u05EA\u05D9\u05E7-\u05EA\u05E7 \u05DE\u05EA\u05D0\u05D9\u05DD \u05DC\u05DB\u05DC \u05E1\u05D5\u05D2\u05D9 \u05D4\u05D4\u05D3\u05E4\u05E1\u05D5\u05EA \u05DE\u05D9\u05D3\u05D4 59 \u05E1\u201D\u05DE",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "classic_baseball",
  colors: ["\u05E6\u05D4\u05D5\u05D1", "\u05E9\u05D7\u05D5\u05E8", "\u05E9\u05D7\u05D5\u05E8 \u05DE\u05DC\u05D0", "\u05DB\u05D7\u05D5\u05DC \u05E8\u05D5\u05D9\u05D0\u05DC", "\u05D0\u05E4\u05D5\u05E8", "\u05D9\u05E8\u05D5\u05E7", "\u05DB\u05EA\u05D5\u05DD", "\u05D5\u05E8\u05D5\u05D3", "\u05E4\u05D5\u05E7\u05E1\u05D9\u05D4", "\u05E1\u05D2\u05D5\u05DC", "\u05D0\u05D3\u05D5\u05DD", "\u05DB\u05D7\u05D5\u05DC", "\u05D8\u05D5\u05E8\u05E7\u05D9\u05D6"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243310/catalog/products/kraus/KR2211/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243310/catalog/products/kraus/KR2211/02.jpg"],
    צהוב: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243311/catalog/products/kraus/KR2211/03.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243312/catalog/products/kraus/KR2211/04.jpg"],
    "שחור מלא": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243312/catalog/products/kraus/KR2211/05.jpg"],
    "כחול רויאל": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243313/catalog/products/kraus/KR2211/06.jpg"],
    אפור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243314/catalog/products/kraus/KR2211/07.jpg"],
    ירוק: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243314/catalog/products/kraus/KR2211/08.jpg"],
    כתום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243317/catalog/products/kraus/KR2211/10.jpg"],
    ורוד: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243318/catalog/products/kraus/KR2211/11.jpg"],
    פוקסיה: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243318/catalog/products/kraus/KR2211/12.jpg"],
    סגול: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243319/catalog/products/kraus/KR2211/13.jpg"],
    אדום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243320/catalog/products/kraus/KR2211/14.jpg"],
    כחול: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243321/catalog/products/kraus/KR2211/15.jpg"],
    טורקיז: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243321/catalog/products/kraus/KR2211/16.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 9
}, {
  sku: "OM6110",
  appearance: 133,
  name: "כובע מצחיה שני צבעים",
  nameHe: "כובע מצחיה שני צבעים",
  description: "כובע אופנתי ואיכותי, מצחייה ישרה מבית העיצוב OMBRE עשוי מבד מלאנז' יוקרתי משולב שני צבעים  סגירה מתכווננת עם תיקתק, 6 פאנל",
  descriptionHe: "כובע אופנתי ואיכותי, מצחייה ישרה מבית העיצוב OMBRE עשוי מבד מלאנז' יוקרתי משולב שני צבעים  סגירה מתכווננת עם תיקתק, 6 פאנל",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "classic_baseball",
  colors: ["אפור"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246250/catalog/products/kraus/OM6110/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246252/catalog/products/kraus/OM6110/03.jpg"],
    אפור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246252/catalog/products/kraus/OM6110/03.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 29
}, {
  sku: "OM6157",
  appearance: 134,
  name: "כובע מצחיה פרמיום",
  nameHe: "כובע מצחיה פרמיום",
  description: "\u05DB\u05D5\u05D1\u05E2 \u05D0\u05D5\u05E4\u05E0\u05EA\u05D9 \u05D5\u05D0\u05D9\u05DB\u05D5\u05EA\u05D9  \u05DE\u05D1\u05D9\u05EA \u05D4\u05E2\u05D9\u05E6\u05D5\u05D1 Ombre  \u05D1\u05E2\u05DC \u05D9\u05DB\u05D5\u05DC\u05EA \u05E0\u05D9\u05D3\u05D5\u05E3 \u05D2\u05D1\u05D5\u05D4\u05D4, 6 \u05E4\u05D0\u05E0\u05DC \u05E2\u05DD \u05E8\u05E6\u05D5\u05E2\u05D5\u05EA \u05D2\u05D5\u05DE\u05D9 \u05DC\u05E0\u05D5\u05D7\u05D5\u05EA \u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9\u05EA, \u05E4\u05DC\u05E7\u05E1",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05D0\u05D5\u05E4\u05E0\u05EA\u05D9 \u05D5\u05D0\u05D9\u05DB\u05D5\u05EA\u05D9  \u05DE\u05D1\u05D9\u05EA \u05D4\u05E2\u05D9\u05E6\u05D5\u05D1 Ombre  \u05D1\u05E2\u05DC \u05D9\u05DB\u05D5\u05DC\u05EA \u05E0\u05D9\u05D3\u05D5\u05E3 \u05D2\u05D1\u05D5\u05D4\u05D4, 6 \u05E4\u05D0\u05E0\u05DC \u05E2\u05DD \u05E8\u05E6\u05D5\u05E2\u05D5\u05EA \u05D2\u05D5\u05DE\u05D9 \u05DC\u05E0\u05D5\u05D7\u05D5\u05EA \u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9\u05EA, \u05E4\u05DC\u05E7\u05E1",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "classic_baseball",
  colors: ["\u05DC\u05D1\u05DF", "\u05D9\u05E8\u05D5\u05E7 \u05D6\u05D9\u05EA", "\u05D0\u05E4\u05D5\u05E8", "\u05DB\u05D7\u05D5\u05DC \u05E0\u05D9\u05D9\u05D1\u05D9", "\u05E9\u05D7\u05D5\u05E8"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246288/catalog/products/kraus/OM6157/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246293/catalog/products/kraus/OM6157/06.jpg"],
    לבן: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246294/catalog/products/kraus/OM6157/07.jpg"],
    "ירוק זית": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246295/catalog/products/kraus/OM6157/08.jpg"],
    אפור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246296/catalog/products/kraus/OM6157/09.jpg"],
    "כחול נייבי": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246297/catalog/products/kraus/OM6157/10.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246298/catalog/products/kraus/OM6157/11.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 29
}, {
  sku: "KR2220",
  appearance: 135,
  name: "כובע דרייפיט",
  nameHe: "כובע דרייפיט",
  description: "\u05DB\u05D5\u05D1\u05E2 \u05DE\u05E6\u05D7\u05D9\u05D4, 6 \u05E4\u05D0\u05E0\u05DC \u05D1\u05D3 \u05DE\u05E0\u05D3\u05E3 \u05D6\u05D9\u05E2\u05D4 \u05D3\u05E8\u05D9\u05D9\u05E4\u05D9\u05D8 \u05E1\u05D2\u05E8 \u05E1\u05E7\u05D5\u05E5\u2019 \u05DE\u05D9\u05D3\u05D4 59 \u05E1\u201D\u05DE",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05DE\u05E6\u05D7\u05D9\u05D4, 6 \u05E4\u05D0\u05E0\u05DC \u05D1\u05D3 \u05DE\u05E0\u05D3\u05E3 \u05D6\u05D9\u05E2\u05D4 \u05D3\u05E8\u05D9\u05D9\u05E4\u05D9\u05D8 \u05E1\u05D2\u05E8 \u05E1\u05E7\u05D5\u05E5\u2019 \u05DE\u05D9\u05D3\u05D4 59 \u05E1\u201D\u05DE",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "classic_baseball",
  colors: ["\u05E9\u05D7\u05D5\u05E8", "\u05DB\u05D7\u05D5\u05DC \u05E8\u05D5\u05D9\u05D0\u05DC", "\u05D8\u05D1\u05E2\u05D9", "\u05D0\u05E4\u05D5\u05E8", "\u05D9\u05E8\u05D5\u05E7 \u05D6\u05D9\u05EA", "\u05D0\u05E4\u05D5\u05E8 \u05DB\u05D4\u05D4", "\u05D0\u05D3\u05D5\u05DD", "\u05DC\u05D1\u05DF"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243354/catalog/products/kraus/KR2220/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243354/catalog/products/kraus/KR2220/01.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243354/catalog/products/kraus/KR2220/02.jpg"],
    "כחול רויאל": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243355/catalog/products/kraus/KR2220/03.jpg"],
    טבעי: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243356/catalog/products/kraus/KR2220/04.jpg"],
    אפור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243356/catalog/products/kraus/KR2220/05.jpg"],
    "ירוק זית": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243357/catalog/products/kraus/KR2220/06.jpg"],
    "אפור כהה": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243358/catalog/products/kraus/KR2220/07.jpg"],
    אדום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243358/catalog/products/kraus/KR2220/08.jpg"],
    לבן: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243359/catalog/products/kraus/KR2220/09.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 12
}, {
  sku: "KR2350",
  appearance: 137,
  name: "כובע פטריה (טמבל)",
  nameHe: "כובע פטריה (טמבל)",
  description: "\u05DB\u05D5\u05D1\u05E2 \u05E4\u05D8\u05E8\u05D9\u05D9\u05D4 \u05DE\u05E4\u05D5\u05DC\u05D9\u05D0\u05E1\u05D8\u05E8 \u05DE\u05D9\u05D3\u05D4 59 \u05E1\u201D\u05DE",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05E4\u05D8\u05E8\u05D9\u05D9\u05D4 \u05DE\u05E4\u05D5\u05DC\u05D9\u05D0\u05E1\u05D8\u05E8 \u05DE\u05D9\u05D3\u05D4 59 \u05E1\u201D\u05DE",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "bucket",
  colors: ["\u05D0\u05E4\u05D5\u05E8 \u05DB\u05D4\u05D4", "\u05E9\u05D7\u05D5\u05E8", "\u05DC\u05D1\u05DF", "\u05D0\u05D3\u05D5\u05DD", "\u05D8\u05D1\u05E2\u05D9", "\u05DB\u05D7\u05D5\u05DC \u05E8\u05D5\u05D9\u05D0\u05DC", "\u05DB\u05D7\u05D5\u05DC \u05E0\u05D9\u05D9\u05D1\u05D9"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243406/catalog/products/kraus/KR2350/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243406/catalog/products/kraus/KR2350/01.jpg"],
    "אפור כהה": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243407/catalog/products/kraus/KR2350/02.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243408/catalog/products/kraus/KR2350/03.jpg"],
    לבן: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243409/catalog/products/kraus/KR2350/04.jpg"],
    אדום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243409/catalog/products/kraus/KR2350/05.jpg"],
    טבעי: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243410/catalog/products/kraus/KR2350/06.jpg"],
    "כחול רויאל": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243411/catalog/products/kraus/KR2350/07.jpg"],
    "כחול נייבי": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243412/catalog/products/kraus/KR2350/08.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 10
}, {
  sku: "OM6500",
  appearance: 138,
  name: "כובע פטריה פרמיום דו-שכבתי",
  nameHe: "כובע פטריה פרמיום דו-שכבתי",
  description: "\u05DB\u05D5\u05D1\u05E2 \u05E4\u05D9\u05D8\u05E8\u05D9\u05D4 \u05D0\u05D5\u05E4\u05E0\u05EA\u05D9 \u05D5\u05D0\u05D9\u05DB\u05D5\u05EA\u05D9 \u05DE\u05D1\u05D9\u05EA \u05D4\u05E2\u05D9\u05E6\u05D5\u05D1 Ombre \u05E2\u05E9\u05D5\u05D9 2 \u05E9\u05DB\u05D1\u05D5\u05EA, \u05D1\u05D3 \u05D2'\u05D9\u05E0\u05E1 \u05D5\u05DB\u05D5\u05EA\u05E0\u05D4 \u05E4\u05E0\u05D9\u05DE\u05D9\u05EA",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05E4\u05D9\u05D8\u05E8\u05D9\u05D4 \u05D0\u05D5\u05E4\u05E0\u05EA\u05D9 \u05D5\u05D0\u05D9\u05DB\u05D5\u05EA\u05D9 \u05DE\u05D1\u05D9\u05EA \u05D4\u05E2\u05D9\u05E6\u05D5\u05D1 Ombre \u05E2\u05E9\u05D5\u05D9 2 \u05E9\u05DB\u05D1\u05D5\u05EA, \u05D1\u05D3 \u05D2'\u05D9\u05E0\u05E1 \u05D5\u05DB\u05D5\u05EA\u05E0\u05D4 \u05E4\u05E0\u05D9\u05DE\u05D9\u05EA",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "bucket",
  colors: ["\u05E9\u05D7\u05D5\u05E8", "\u05DB\u05D7\u05D5\u05DC \u05E0\u05D9\u05D9\u05D1\u05D9", "\u05D0\u05E4\u05D5\u05E8"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246340/catalog/products/kraus/OM6500/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246341/catalog/products/kraus/OM6500/02.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246343/catalog/products/kraus/OM6500/05.jpg"],
    "כחול נייבי": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246343/catalog/products/kraus/OM6500/06.jpg"],
    אפור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769246344/catalog/products/kraus/OM6500/07.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 32
}, {
  sku: "KR2382",
  appearance: 140,
  name: "כיפה זאמש",
  nameHe: "כיפה זאמש",
  description: "\u05DB\u05D9\u05E4\u05D4 \u05E2\u05E9\u05D5\u05D9\u05D4 \u05E2\u05D5\u05E8 \u05D4\u05E4\u05D5\u05DA, \u05D6\u05DE\u05E9 \u05DE\u05D9\u05D3\u05D4 17 \u05E1\u201D\u05DE",
  descriptionHe: "\u05DB\u05D9\u05E4\u05D4 \u05E2\u05E9\u05D5\u05D9\u05D4 \u05E2\u05D5\u05E8 \u05D4\u05E4\u05D5\u05DA, \u05D6\u05DE\u05E9 \u05DE\u05D9\u05D3\u05D4 17 \u05E1\u201D\u05DE",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "kippot",
  colors: ["\u05D7\u05D5\u05DD", "\u05DB\u05D7\u05D5\u05DC \u05E0\u05D9\u05D9\u05D1\u05D9"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243429/catalog/products/kraus/KR2382/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243429/catalog/products/kraus/KR2382/01.jpg"],
    חום: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243430/catalog/products/kraus/KR2382/02.jpg"],
    "כחול נייבי": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243431/catalog/products/kraus/KR2382/03.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 12
}, {
  sku: "KR2381",
  appearance: 139,
  name: "כיפה סאטן",
  nameHe: "כיפה סאטן",
  description: "כיפה עשויה סאטן עם ביטנה פנימית מידה 20 ס”מ",
  descriptionHe: "כיפה עשויה סאטן עם ביטנה פנימית מידה 20 ס”מ",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "kippot",
  colors: ["לבן"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243429/catalog/products/kraus/KR2381/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243429/catalog/products/kraus/KR2381/01.jpg"],
    לבן: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243429/catalog/products/kraus/KR2381/01.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 5
}, {
  sku: "KR2385",
  appearance: 141,
  name: "כיפה מפשתן",
  nameHe: "כיפה מפשתן",
  description: "כיפה עשויה פשתן עם ביטנה פנימית וסיכה מובנית פנימית מידה 18 ס”מ",
  descriptionHe: "כיפה עשויה פשתן עם ביטנה פנימית וסיכה מובנית פנימית מידה 18 ס”מ",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "kippot",
  colors: ["טבעי"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243432/catalog/products/kraus/KR2385/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243434/catalog/products/kraus/KR2385/02.jpg"],
    טבעי: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243432/catalog/products/kraus/KR2385/01.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 11
}, {
  sku: "KPK",
  appearance: 142,
  name: "\u05DB\u05D9\u05E4\u05D4 \u05E7\u05D8\u05D9\u05E4\u05D4",
  nameHe: "\u05DB\u05D9\u05E4\u05D4 \u05E7\u05D8\u05D9\u05E4\u05D4",
  description: "\u05DB\u05D9\u05E4\u05D4 \u05E7\u05D8\u05D9\u05E4\u05D4 | \u05DE\u05E7\"\u05D8 \u05E1\u05E4\u05E7: KPK | \u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4: \u05DE\u05D5\u05E6\u05E8\u05D9 \u05E1\u05D5\u05D1\u05DC\u05D9\u05DE\u05E6\u05D9\u05D4 | \u05E6\u05D1\u05E2: \u05E9\u05D7\u05D5\u05E8",
  descriptionHe: "\u05DB\u05D9\u05E4\u05D4 \u05E7\u05D8\u05D9\u05E4\u05D4 | \u05DE\u05E7\"\u05D8 \u05E1\u05E4\u05E7: KPK | \u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4: \u05DE\u05D5\u05E6\u05E8\u05D9 \u05E1\u05D5\u05D1\u05DC\u05D9\u05DE\u05E6\u05D9\u05D4 | \u05E6\u05D1\u05E2: \u05E9\u05D7\u05D5\u05E8",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "kippot",
  colors: ["\u05E9\u05D7\u05D5\u05E8"],
  sizeRange: ["one-size"],
  images: {
    base1: ["/product_images/kpk/kpk.png"],
    base2: ["/product_images/kpk/kpk.png"],
    שחור: ["/product_images/kpk/kpk.png"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 45
}, {
  sku: "KR2310",
  appearance: 143,
  name: "כובע לגיונר",
  nameHe: "כובע לגיונר",
  description: "\u05DB\u05D5\u05D1\u05E2 5 \u05E4\u05D0\u05E0\u05DC \u05E2\u05DD \u05D4\u05D2\u05E0\u05D4 \u05DC\u05E2\u05D5\u05E8\u05E3  100% \u05E4\u05D5\u05DC\u05D9\u05D0\u05E1\u05D8\u05E8 \u05DE\u05D9\u05D3\u05D4 60 \u05E1\u201D\u05DE",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 5 \u05E4\u05D0\u05E0\u05DC \u05E2\u05DD \u05D4\u05D2\u05E0\u05D4 \u05DC\u05E2\u05D5\u05E8\u05E3  100% \u05E4\u05D5\u05DC\u05D9\u05D0\u05E1\u05D8\u05E8 \u05DE\u05D9\u05D3\u05D4 60 \u05E1\u201D\u05DE",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "legionary",
  colors: ["\u05D8\u05D1\u05E2\u05D9", "\u05E9\u05D7\u05D5\u05E8", "\u05DB\u05D7\u05D5\u05DC \u05E8\u05D5\u05D9\u05D0\u05DC", "\u05DC\u05D1\u05DF"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243392/catalog/products/kraus/KR2310/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243392/catalog/products/kraus/KR2310/01.jpg"],
    טבעי: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243393/catalog/products/kraus/KR2310/02.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243393/catalog/products/kraus/KR2310/03.jpg"],
    "כחול רויאל": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243394/catalog/products/kraus/KR2310/04.jpg"],
    לבן: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243395/catalog/products/kraus/KR2310/05.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 17
}, {
  sku: "KR2353",
  appearance: 144,
  name: "כובע לגיונר רחב ושוליים",
  nameHe: "כובע לגיונר רחב ושוליים",
  description: "\u05DB\u05D5\u05D1\u05E2 \u05E8\u05D7\u05D1 \u05E9\u05D5\u05DC\u05D9\u05D9\u05DD \u05E2\u05DD \u05E4\u05EA\u05D7\u05D9 \u05D0\u05D5\u05D5\u05E8\u05D5\u05E8 \u05D5\u05DE\u05D2\u05DF \u05E2\u05D5\u05E8\u05E3 \u05D1\u05D3 \u05DE\u05D9\u05E7\u05E8\u05D5\u05E4\u05D9\u05D9\u05D1\u05E8 \u05D0\u05D9\u05DB\u05D5\u05EA\u05D9 \u05DE\u05E0\u05D3\u05E3 \u05D6\u05D9\u05E8\u05D4 59 \u05E1\"\u05DE",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05E8\u05D7\u05D1 \u05E9\u05D5\u05DC\u05D9\u05D9\u05DD \u05E2\u05DD \u05E4\u05EA\u05D7\u05D9 \u05D0\u05D5\u05D5\u05E8\u05D5\u05E8 \u05D5\u05DE\u05D2\u05DF \u05E2\u05D5\u05E8\u05E3 \u05D1\u05D3 \u05DE\u05D9\u05E7\u05E8\u05D5\u05E4\u05D9\u05D9\u05D1\u05E8 \u05D0\u05D9\u05DB\u05D5\u05EA\u05D9 \u05DE\u05E0\u05D3\u05E3 \u05D6\u05D9\u05E8\u05D4 59 \u05E1\"\u05DE",
  tech: "DTF",
  search_tag: ["all", "headwear"],
  headwearType: "legionary",
  colors: ["\u05DC\u05D1\u05DF", "\u05E9\u05D7\u05D5\u05E8", "\u05D8\u05D1\u05E2\u05D9", "\u05D0\u05E4\u05D5\u05E8 \u05DB\u05D4\u05D4"],
  sizeRange: ["one-size"],
  images: {
    base1: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243417/catalog/products/kraus/KR2353/01.jpg"],
    base2: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243421/catalog/products/kraus/KR2353/06.jpg"],
    לבן: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243418/catalog/products/kraus/KR2353/02.jpg"],
    שחור: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243419/catalog/products/kraus/KR2353/03.jpg"],
    טבעי: ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243419/catalog/products/kraus/KR2353/04.jpg"],
    "אפור כהה": ["https://res.cloudinary.com/dkdpwgsyl/image/upload/v1769243420/catalog/products/kraus/KR2353/05.jpg"]
  },
  activePrintAreas: ["cap_front", "cap_back"],
  basePrice: 45
}, {
  sku: "beanie",
  appearance: 10121,
  name: "beanie",
  nameHe: "\u05DB\u05D5\u05D1\u05E2 \u05E6\u05DE\u05E8",
  description: "beanie",
  descriptionHe: "\u05DB\u05D5\u05D1\u05E2 \u05E6\u05DE\u05E8",
  tech: "DTF",
  search_tag: ["all", "winter", "headwear", "accessories"],
  colors: ["black", "olive"],
  sizeRange: ["one-size"],
  activePrintAreas: ["cap_front", "cap_back"],
  images: {
    base1: ["/product_images/beanie/base1_beanie.avif", "/product_images/beanie/base1_beanie.webp", "/product_images/beanie/base1_beanie.png"],
    base2: ["/product_images/beanie/base2_beanie.avif", "/product_images/beanie/base2_beanie.webp", "/product_images/beanie/base2_beanie.png"],
    black: ["/product_images/beanie/black_beanie.avif", "/product_images/beanie/black_beanie.webp", "/product_images/beanie/black_beanie.jpg"],
    olive: ["/product_images/beanie/olive_beanie.avif", "/product_images/beanie/olive_beanie.webp", "/product_images/beanie/olive_beanie.jpg"]
  },
  basePrice: 10
}];

// Hebrew labels for color keys used across the UI
export const colorLabelsHe = {
  white: 'לבן',
  black: 'שחור',
  navy: 'כחול נייבי',
  red: 'אדום',
  gray: 'אפור',
  blue: 'כחול רויאל',
  olive: 'ירוק זית',
  purple: 'סגול',
  lightblue: 'תכלת',
  bottlegreen: 'ירוק בקבוק',
  tourquise: 'טורקיז',
  babypink: 'ורוד בייבי',
  yellow: 'צהוב'
};

// add additional Hebrew labels for hoodie colors
Object.assign(colorLabelsHe, {
  benetongreen: 'ירוק בניטון',
  bordo: 'בורדו',
  tourquise: 'טורקיז',
  orange: 'כתום',
  lightblue: 'תכלת',
  brown: 'חום',
  red: 'אדום',
  blue: 'כחול',
  babypink: 'ורוד בייבי',
  bottlegreen: 'ירוק בקבוק',
  olive: 'ירוק זית',
  white: 'לבן',
  gray: 'אפור',
  yellow: 'צהוב',
  purple: 'סגול',
  navy: 'כחול נייבי',
  black: 'שחור',
  brown: 'חום'
});

// Hebrew labels for dryfit colors (match canonical keys)
Object.assign(colorLabelsHe, {
  apple_green: 'ירוק תפוח',
  banana_yellow: 'צהוב בננה',
  natural: 'טבעי',
  phosphor_yellow: 'צהוב זוהר',
  phosphor_green: 'ירוק זוהר',
  phosphor_pink: 'ורוד זוהר',
  fuksia: 'פוקסיה',
  lilac: 'סגלגל',
  offwhite: 'שנהב',
  royal_blue: 'כחול רויאל',
  navy: ' נייבי',
  babypink: 'ורוד בייבי'
});
// Active print fees include 18% VAT; neckLabel is inactive and unchanged.
export const printAreas = {
  leftChest: {
    key: 'leftChest',
    label: 'Left Chest',
    labelHe: 'חזה שמאל',
    emboAllowed: true,
    maxWCm: 10,
    maxHCm: 10,
    overlayX: 150,
    overlayY: 200,
    overlayW: 120,
    overlayH: 120,
    overlayRot: 0,
    priority: 1,
    fee: 6
  },
  rightChest: {
    key: 'rightChest',
    label: 'Right Chest',
    labelHe: 'חזה ימין',
    emboAllowed: true,
    maxWCm: 10,
    maxHCm: 10,
    overlayX: 530,
    overlayY: 200,
    overlayW: 120,
    overlayH: 120,
    overlayRot: 0,
    priority: 2,
    fee: 6
  },
  frontA4: {
    key: 'frontA4',
    label: 'Front A4',
    labelHe: 'חזית A4',
    emboAllowed: false,
    maxWCm: 20,
    maxHCm: 30,
    overlayX: 250,
    overlayY: 250,
    overlayW: 300,
    overlayH: 400,
    overlayRot: 0,
    priority: 3,
    fee: 12
  },
  frontA3: {
    key: 'frontA3',
    label: 'Front A3',
    labelHe: 'חזית A3',
    emboAllowed: false,
    maxWCm: 30,
    maxHCm: 40,
    overlayX: 200,
    overlayY: 200,
    overlayW: 400,
    overlayH: 500,
    overlayRot: 0,
    priority: 4,
    fee: 18
  },
  backA4: {
    key: 'backA4',
    label: 'Back A4',
    labelHe: 'גב A4',
    emboAllowed: false,
    maxWCm: 20,
    maxHCm: 30,
    overlayX: 250,
    overlayY: 250,
    overlayW: 300,
    overlayH: 400,
    overlayRot: 0,
    priority: 5,
    fee: 12
  },
  backA3: {
    key: 'backA3',
    label: 'Back A3',
    labelHe: 'גב A3',
    emboAllowed: false,
    maxWCm: 30,
    maxHCm: 40,
    overlayX: 200,
    overlayY: 200,
    overlayW: 400,
    overlayH: 500,
    overlayRot: 0,
    priority: 6,
    fee: 18
  },
  leftSleeve: {
    key: 'leftSleeve',
    label: 'Left Sleeve',
    labelHe: 'שרוול שמאל',
    emboAllowed: true,
    maxWCm: 8,
    maxHCm: 8,
    overlayX: 50,
    overlayY: 300,
    overlayW: 80,
    overlayH: 200,
    overlayRot: 0,
    priority: 7,
    fee: 6
  },
  rightSleeve: {
    key: 'rightSleeve',
    label: 'Right Sleeve',
    labelHe: 'שרוול ימין',
    emboAllowed: true,
    maxWCm: 8,
    maxHCm: 8,
    overlayX: 670,
    overlayY: 300,
    overlayW: 80,
    overlayH: 200,
    overlayRot: 0,
    priority: 8,
    fee: 6
  },
  neckLabel: {
    key: 'neckLabel',
    label: 'Neck Label',
    labelHe: 'תווית צוואר',
    emboAllowed: true,
    maxWCm: 5,
    maxHCm: 2,
    overlayX: 350,
    overlayY: 100,
    overlayW: 100,
    overlayH: 40,
    overlayRot: 0,
    priority: 9,
    fee: 3
  },
  // Long sleeve versions - same labels, different images
  leftChest_long: {
    key: 'leftChest_long',
    label: 'Left Chest',
    labelHe: 'חזה שמאל',
    emboAllowed: true,
    maxWCm: 10,
    maxHCm: 10,
    overlayX: 150,
    overlayY: 200,
    overlayW: 120,
    overlayH: 120,
    overlayRot: 0,
    priority: 1,
    fee: 6
  },
  rightChest_long: {
    key: 'rightChest_long',
    label: 'Right Chest',
    labelHe: 'חזה ימין',
    emboAllowed: true,
    maxWCm: 10,
    maxHCm: 10,
    overlayX: 530,
    overlayY: 200,
    overlayW: 120,
    overlayH: 120,
    overlayRot: 0,
    priority: 2,
    fee: 6
  },
  frontA4_long: {
    key: 'frontA4_long',
    label: 'Front A4',
    labelHe: 'חזית A4',
    emboAllowed: false,
    maxWCm: 20,
    maxHCm: 30,
    overlayX: 250,
    overlayY: 250,
    overlayW: 300,
    overlayH: 400,
    overlayRot: 0,
    priority: 3,
    fee: 12
  },
  frontA3_long: {
    key: 'frontA3_long',
    label: 'Front A3',
    labelHe: 'חזית A3',
    emboAllowed: false,
    maxWCm: 30,
    maxHCm: 40,
    overlayX: 200,
    overlayY: 200,
    overlayW: 400,
    overlayH: 500,
    overlayRot: 0,
    priority: 4,
    fee: 18
  },
  backA4_long: {
    key: 'backA4_long',
    label: 'Back A4',
    labelHe: 'גב A4',
    emboAllowed: false,
    maxWCm: 20,
    maxHCm: 30,
    overlayX: 250,
    overlayY: 250,
    overlayW: 300,
    overlayH: 400,
    overlayRot: 0,
    priority: 5,
    fee: 12
  },
  backA3_long: {
    key: 'backA3_long',
    label: 'Back A3',
    labelHe: 'גב A3',
    emboAllowed: false,
    maxWCm: 30,
    maxHCm: 40,
    overlayX: 200,
    overlayY: 200,
    overlayW: 400,
    overlayH: 500,
    overlayRot: 0,
    priority: 6,
    fee: 18
  },
  leftSleeve_long: {
    key: 'leftSleeve_long',
    label: 'Left Sleeve',
    labelHe: 'שרוול שמאל',
    emboAllowed: true,
    maxWCm: 8,
    maxHCm: 8,
    overlayX: 50,
    overlayY: 300,
    overlayW: 80,
    overlayH: 200,
    overlayRot: 0,
    priority: 7,
    fee: 6
  },
  rightSleeve_long: {
    key: 'rightSleeve_long',
    label: 'Right Sleeve',
    labelHe: 'שרוול ימין',
    emboAllowed: true,
    maxWCm: 8,
    maxHCm: 8,
    overlayX: 670,
    overlayY: 300,
    overlayW: 80,
    overlayH: 200,
    overlayRot: 0,
    priority: 8,
    fee: 6
  },
  cap_front: {
    key: 'cap_front',
    label: 'Cap Front',
    labelHe: 'חזית כובע',
    emboAllowed: true,
    maxWCm: 10,
    maxHCm: 6,
    overlayX: 250,
    overlayY: 350,
    overlayW: 300,
    overlayH: 180,
    overlayRot: 0,
    priority: 9,
    fee: 6
  },
  cap_back: {
    key: 'cap_back',
    label: 'Cap Back',
    labelHe: 'גב כובע',
    emboAllowed: true,
    maxWCm: 10,
    maxHCm: 4,
    overlayX: 250,
    overlayY: 350,
    overlayW: 300,
    overlayH: 180,
    overlayRot: 0,
    priority: 10,
    fee: 6
  }
};
// Canonical customer-facing unit prices include 18% VAT.
export const pricingRules = {
  tshirt: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 40
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  hoodie: {
    tiers: [{
      min: 1,
      max: 9,
      price: 100
    }, {
      min: 10,
      max: 19,
      price: 75
    }, {
      min: 20,
      max: 49,
      price: 55
    }, {
      min: 50,
      max: 99,
      price: 45
    }, {
      min: 100,
      max: Infinity,
      price: 40
    }]
  },
  dryfit: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 40
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  sweatshirt: {
    tiers: [{
      min: 1,
      max: 9,
      price: 85
    }, {
      min: 10,
      max: 19,
      price: 60
    }, {
      min: 20,
      max: 49,
      price: 45
    }, {
      min: 50,
      max: 99,
      price: 40
    }, {
      min: 100,
      max: Infinity,
      price: 35
    }]
  },
  fleece: {
    tiers: [{
      min: 1,
      max: 9,
      price: 125
    }, {
      min: 10,
      max: 19,
      price: 100
    }, {
      min: 20,
      max: 49,
      price: 90
    }, {
      min: 50,
      max: 99,
      price: 75
    }, {
      min: 100,
      max: Infinity,
      price: 70
    }]
  },
  softshell: {
    tiers: [{
      min: 1,
      max: 9,
      price: 150
    }, {
      min: 10,
      max: 19,
      price: 125
    }, {
      min: 20,
      max: 49,
      price: 105
    }, {
      min: 50,
      max: 99,
      price: 100
    }, {
      min: 100,
      max: Infinity,
      price: 95
    }]
  },
  longsleeve: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 55
    }, {
      min: 20,
      max: 49,
      price: 35
    }, {
      min: 50,
      max: 99,
      price: 30
    }, {
      min: 100,
      max: Infinity,
      price: 25
    }]
  },
  longsleeve_dryfit: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 55
    }, {
      min: 20,
      max: 49,
      price: 35
    }, {
      min: 50,
      max: 99,
      price: 30
    }, {
      min: 100,
      max: Infinity,
      price: 25
    }]
  },
  polo: {
    tiers: [{
      min: 1,
      max: 9,
      price: 75
    }, {
      min: 10,
      max: 19,
      price: 55
    }, {
      min: 20,
      max: 49,
      price: 35
    }, {
      min: 50,
      max: 99,
      price: 30
    }, {
      min: 100,
      max: Infinity,
      price: 25
    }]
  },
  zipped_hood: {
    tiers: [{
      min: 1,
      max: 9,
      price: 90
    }, {
      min: 10,
      max: 19,
      price: 65
    }, {
      min: 20,
      max: 49,
      price: 55
    }, {
      min: 50,
      max: 99,
      price: 45
    }, {
      min: 100,
      max: Infinity,
      price: 40
    }]
  },
  beanie: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  fleece_beanie: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  rerr: {
    tiers: [{
      min: 1,
      max: 9,
      price: 50
    }, {
      min: 10,
      max: 19,
      price: 30
    }, {
      min: 20,
      max: 49,
      price: 20
    }, {
      min: 50,
      max: 99,
      price: 15
    }, {
      min: 100,
      max: Infinity,
      price: 10
    }]
  },
  scarf: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  KR2020: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  KR2210: {
    tiers: [{
      min: 1,
      max: 9,
      price: 65
    }, {
      min: 10,
      max: 19,
      price: 40
    }, {
      min: 20,
      max: 49,
      price: 30
    }, {
      min: 50,
      max: 99,
      price: 25
    }, {
      min: 100,
      max: Infinity,
      price: 18
    }]
  },
  KR2211: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  OM6110: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 40
    }, {
      min: 20,
      max: 49,
      price: 35
    }, {
      min: 50,
      max: 99,
      price: 30
    }, {
      min: 100,
      max: Infinity,
      price: 25
    }]
  },
  OM6157: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 40
    }, {
      min: 20,
      max: 49,
      price: 35
    }, {
      min: 50,
      max: 99,
      price: 30
    }, {
      min: 100,
      max: Infinity,
      price: 25
    }]
  },
  KR2220: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  KR2350: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  OM6500: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 40
    }, {
      min: 20,
      max: 49,
      price: 35
    }, {
      min: 50,
      max: 99,
      price: 30
    }, {
      min: 100,
      max: Infinity,
      price: 25
    }]
  },
  KR2381: {
    tiers: [{
      min: 1,
      max: 9,
      price: 35
    }, {
      min: 10,
      max: 19,
      price: 25
    }, {
      min: 20,
      max: 49,
      price: 18
    }, {
      min: 50,
      max: 99,
      price: 12
    }, {
      min: 100,
      max: Infinity,
      price: 6
    }]
  },
  KR2385: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  KR2382: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  KPK: {
    tiers: [{
      min: 1,
      max: 9,
      price: 60
    }, {
      min: 10,
      max: 19,
      price: 35
    }, {
      min: 20,
      max: 49,
      price: 25
    }, {
      min: 50,
      max: 99,
      price: 18
    }, {
      min: 100,
      max: Infinity,
      price: 12
    }]
  },
  KR2310: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 40
    }, {
      min: 20,
      max: 49,
      price: 35
    }, {
      min: 50,
      max: 99,
      price: 30
    }, {
      min: 100,
      max: Infinity,
      price: 25
    }]
  },
  KR2353: {
    tiers: [{
      min: 1,
      max: 9,
      price: 70
    }, {
      min: 10,
      max: 19,
      price: 40
    }, {
      min: 20,
      max: 49,
      price: 35
    }, {
      min: 50,
      max: 99,
      price: 30
    }, {
      min: 100,
      max: Infinity,
      price: 25
    }]
  }
};
function cloneTemplatePresetMap(source) {
  return Object.fromEntries(Object.entries(source).map(([key, value]) => [key, {
    ...value
  }]));
}
const shortSleeveTemplatePresets = {
  frontA4: {
    x: 35,
    y: 22,
    w: 30,
    h: 40,
    rot: 0
  },
  frontA3: {
    x: 32.5,
    y: 20,
    w: 34,
    h: 50,
    rot: 0
  },
  backA4: {
    x: 35,
    y: 23,
    w: 30,
    h: 40,
    rot: 0
  },
  backA3: {
    x: 33,
    y: 20,
    w: 34,
    h: 50,
    rot: 0
  },
  leftChest: {
    x: 53,
    y: 25,
    w: 16,
    h: 16,
    rot: 0
  },
  rightChest: {
    x: 33,
    y: 27,
    w: 16,
    h: 16,
    rot: 0
  },
  leftSleeve: {
    x: 74,
    y: 27,
    w: 12,
    h: 10,
    rot: -10
  },
  rightSleeve: {
    x: 13,
    y: 27,
    w: 12,
    h: 10,
    rot: 10
  },
  neckLabel: {
    x: 38,
    y: 4,
    w: 24,
    h: 12,
    rot: 0
  },
  cap_front: {
    x: 30,
    y: 39,
    w: 40,
    h: 22,
    rot: 0
  },
  cap_back: {
    x: 30,
    y: 41,
    w: 40,
    h: 14,
    rot: 0
  }
};
const longSleeveTemplatePresets = {
  leftChest_long: {
    x: 53,
    y: 25,
    w: 16,
    h: 16,
    rot: 0
  },
  rightChest_long: {
    x: 31,
    y: 27,
    w: 16,
    h: 16,
    rot: 0
  },
  frontA4_long: {
    x: 35,
    y: 20,
    w: 30,
    h: 40,
    rot: 0
  },
  frontA3_long: {
    x: 33,
    y: 20,
    w: 34,
    h: 50,
    rot: 0
  },
  backA4_long: {
    x: 35,
    y: 23,
    w: 30,
    h: 40,
    rot: 0
  },
  backA3_long: {
    x: 30,
    y: 22,
    w: 40,
    h: 55,
    rot: 0
  },
  leftSleeve_long: {
    x: 74,
    y: 27,
    w: 12,
    h: 10,
    rot: -10
  },
  rightSleeve_long: {
    x: 13,
    y: 27,
    w: 12,
    h: 10,
    rot: 10
  }
};
const hoodedTemplatePresets = {
  leftChest_long: {
    x: 53,
    y: 25,
    w: 16,
    h: 16,
    rot: 0
  },
  rightChest_long: {
    x: 31,
    y: 27,
    w: 16,
    h: 16,
    rot: 0
  },
  frontA4_long: {
    x: 35,
    y: 25,
    w: 30,
    h: 35,
    rot: 0
  },
  frontA3_long: {
    x: 33,
    y: 20,
    w: 34,
    h: 50,
    rot: 0
  },
  backA4_long: {
    x: 35,
    y: 28,
    w: 30,
    h: 35,
    rot: 0
  },
  backA3_long: {
    x: 32.5,
    y: 29,
    w: 35,
    h: 40,
    rot: 0
  },
  leftSleeve_long: {
    x: 74,
    y: 27,
    w: 12,
    h: 10,
    rot: -10
  },
  rightSleeve_long: {
    x: 13,
    y: 27,
    w: 12,
    h: 10,
    rot: 10
  }
};
export const templatePresets = {
  // Each product gets its own placement block. Start by editing the SKU you care about.
  tshirt: {
    ...cloneTemplatePresetMap(shortSleeveTemplatePresets)
  },
  dryfit: {
    ...cloneTemplatePresetMap(shortSleeveTemplatePresets)
  },
  polo: {
    ...cloneTemplatePresetMap(shortSleeveTemplatePresets)
  },
  sweatshirt: {
    ...cloneTemplatePresetMap(hoodedTemplatePresets)
  },
  fleece: {
    ...cloneTemplatePresetMap(hoodedTemplatePresets)
  },
  softshell: {
    ...cloneTemplatePresetMap(hoodedTemplatePresets)
  },
  longsleeve: {
    ...cloneTemplatePresetMap(longSleeveTemplatePresets)
  },
  longsleeve_dryfit: {
    ...cloneTemplatePresetMap(longSleeveTemplatePresets)
  },
  // Hooded garments get their own editable template family.
  hoodie: {
    ...cloneTemplatePresetMap(hoodedTemplatePresets)
  },
  zipped_hood: {
    ...cloneTemplatePresetMap(hoodedTemplatePresets)
  }
};

// end of file

// --- normalize image entries to prefer .avif then .webp then original ---
(function normalizeProductImages() {
  try {
    if (!Array.isArray(exports && exports.products ? exports.products : products)) return;
  } catch (err) {
    // fallback: products in scope
  }
  const list = typeof products !== 'undefined' && Array.isArray(products) ? products : exports && exports.products || [];
  const isRaster = s => typeof s === 'string' && /\.(jpe?g|png)$/i.test(s);
  for (const p of list) {
    if (!p || typeof p !== 'object' || !p.images) continue;
    for (const key of Object.keys(p.images)) {
      const val = p.images[key];
      if (Array.isArray(val)) {
        const out = [];
        for (const item of val) {
          if (isRaster(item)) {
            const av = item.replace(/\.[^.]+$/, '.avif');
            const wp = item.replace(/\.[^.]+$/, '.webp');
            if (!out.includes(av)) out.push(av);
            if (!out.includes(wp)) out.push(wp);
            if (!out.includes(item)) out.push(item);
          } else {
            if (!out.includes(item)) out.push(item);
          }
        }
        p.images[key] = out;
      } else if (typeof val === 'string') {
        if (isRaster(val)) {
          const av = val.replace(/\.[^.]+$/, '.avif');
          const wp = val.replace(/\.[^.]+$/, '.webp');
          p.images[key] = [av, wp, val];
        }
      }
    }
  }
})();
